<script setup lang="ts">
  import { computed } from 'vue';
  import type { CompiledStaticNode } from '@record-fill';
  import { useElementContainerStyles } from '../../model/useElementContainerStyles';

  const props = defineProps<{ node: CompiledStaticNode }>();

  const { containerStyles } = useElementContainerStyles(
    computed(() => props.node.element.properties),
    'FIXED_TEXT',
  );
</script>

<template>
  <div
    v-if="node.visible"
    class="m-0 overflow-hidden text-ellipsis whitespace-nowrap [font-family:var(--font-base)] text-[var(--color-gray-07)]"
    :style="containerStyles"
  >
    {{ node.text.replace(/[\r\n]+/g, ' ').trim() }}
  </div>
</template>
